import {
  Box,
  Divider,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import VSNTypography from "../../../shared/VSNTypography";
import { EventScheduleStyle } from "./EventScheduleStyle";

const EventEmailPreviewModal = ({ data, title, list, subTitle = "" }) => {
  const classes = EventScheduleStyle();
  return (
    <Box sx={{ position: "relative" }}>
      <Box className={classes.modalHeader}>
        <Stack>
          <Stack py={3} gap={0.5}>
            <VSNTypography variant="h4" className={classes.title}>
              {title}
            </VSNTypography>
            <VSNTypography variant="body1">{subTitle}</VSNTypography>
          </Stack>
        </Stack>

        <Divider sx={{ borderColor: "#EAEDF0" }} />
      </Box>

      {list && (
        <TableContainer
          sx={{
            width: "100%",
            mx: "auto",
            pb: 2,
            "& .MuiTableBody-root .MuiTableRow-root": {
              borderBottom: "1px dashed #EAEDF0",
              "&:last-of-type": { borderBottom: 0 },
              "& .MuiTableCell-root": { border: 0 },
            },
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Member Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Service Level</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data?.length > 0 ? (
                data?.map((item, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.service_level}</TableCell>
                    <TableCell>{item.email}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={3}
                    sx={{ textAlign: "center", color: "gray" }}
                  >
                    No Roster Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default EventEmailPreviewModal;
